import _ from 'lodash'
import axios from 'axios'
import weui from 'weui.js'
import {state} from '@/store/store.js'

let loadingMessage = '' // '加载中'

export function requestSuccessHandler (config) {
  if (state.debug) {
    console.log('requestSuccessHandler', 'config', config)
  }

  if (config.loading === false) { // do not show loading
  } else if (config.loading) { // custom message
    config.loading = weui.loading(config.loading)
  } else { // default
    config.loading = weui.loading(loadingMessage)
  }
  return config
}
export function requestFailureHandler (error) {
  return Promise.reject(error)
}
export function responseSuccessHandler (res) {
  // let {config, data} = res
  if (state.debug) {
    console.log('responseSuccessHandler', 'res.config.url', _.get(res, 'config.url'))
    console.log('responseSuccessHandler', 'res.data', res.data)
  }
  let loading = _.get(res, 'config.loading', {})
  if (loading && loading.hide) {
    loading.hide()
  }
  return res
}
export function responseFailureHandler (error) {
  // let {request, response, config} = error
  if (state.debug) {
    console.error('responseFailureHandler', 'error', error)
  }
  let loading = _.get(error, 'config.loading', {})
  if (loading && loading.hide) {
    loading.hide()
  }
  return Promise.reject(error)
}

axios.interceptors.request.use(requestSuccessHandler, requestFailureHandler)
axios.interceptors.response.use(responseSuccessHandler, responseFailureHandler)

export default axios



// WEBPACK FOOTER //
// ./src/plugin/axios.js